// src/queries/venue.query.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, putRequest, deleteRequest } from 'utils/http'

const VENUE_QUERY_KEY = 'venues'

export const getVenues = async (current = 1, pageSize = 20, search = '') => {
  return getRequest('venues', {
    params: {
      page: current,
      pageSize,
      searchQuery: search,
    },
  })
}

export const useGetVenues = (current = 1, pageSize = 20, search = '') => {
  return useQuery({
    queryKey: [VENUE_QUERY_KEY, current, pageSize, search],
    queryFn: () => getVenues(current, pageSize, search),
  })
}

export const getVenue = async (id) => {
  return getRequest(`venues/${id}`)
}

export const useGetVenue = (id) => {
  return useQuery({
    queryKey: [VENUE_QUERY_KEY, id],
    queryFn: () => getVenue(id),
    enabled: !!id,
  })
}

export const createVenue = async (data) => {
  return postRequest('venues', data)
}

export const useCreateVenue = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createVenue,
    onSuccess: () => {
      queryClient.invalidateQueries([VENUE_QUERY_KEY])
    },
  })
}

export const updateVenue = async ({ id, data }) => {
  return putRequest(`venues/${id}`, data)
}

export const useUpdateVenue = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateVenue,
    onSuccess: () => {
      queryClient.invalidateQueries([VENUE_QUERY_KEY])
    },
  })
}

export const deleteVenue = async (id) => {
  return deleteRequest(`venues/${id}`)
}

export const useDeleteVenue = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteVenue,
    onSuccess: () => {
      queryClient.invalidateQueries([VENUE_QUERY_KEY])
    },
  })
}
